/**
 * Aurora canvas — atmospheric background for auth screens.
 * Strategically placed emerald blobs (no infinite animation = no AI feel).
 */
export function AuroraCanvas({ children }) {
    return (
        <div className="aurora-canvas" style={{
            minHeight: '100dvh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '2rem 1rem',
            position: 'relative',
            overflow: 'hidden',
        }}>
            {/* Aurora orbital decorations */}
            <div
                aria-hidden="true"
                style={{
                    pointerEvents: 'none',
                    position: 'absolute',
                    top: '12%',
                    right: '-180px',
                    width: '620px',
                    height: '620px',
                    borderRadius: '50%',
                    background: 'radial-gradient(circle, rgba(0,214,143,0.18) 0%, transparent 65%)',
                    filter: 'blur(48px)',
                    opacity: 0.85,
                }}
            />
            <div
                aria-hidden="true"
                style={{
                    pointerEvents: 'none',
                    position: 'absolute',
                    bottom: '-220px',
                    left: '-180px',
                    width: '720px',
                    height: '720px',
                    borderRadius: '50%',
                    background: 'radial-gradient(circle, rgba(95,255,203,0.10) 0%, transparent 60%)',
                    filter: 'blur(56px)',
                    opacity: 0.8,
                }}
            />
            {/* Origin point glow at bottom-center */}
            <div className="origin-anchor" aria-hidden="true" />

            {/* Decorative grid/line accents in corners */}
            <svg
                aria-hidden="true"
                style={{ position: 'absolute', top: '24px', left: '24px', pointerEvents: 'none' }}
                width="80"
                height="80"
                viewBox="0 0 80 80"
                fill="none"
            >
                <path className="line-path" d="M0 12 L12 12 L12 0" stroke="rgba(0,214,143,0.40)" strokeWidth="1.2" strokeLinecap="round" />
                <path className="line-path" d="M24 12 L40 12" stroke="rgba(255,255,255,0.10)" strokeWidth="1" />
                <path className="line-path" d="M12 24 L12 40" stroke="rgba(255,255,255,0.10)" strokeWidth="1" />
            </svg>
            <svg
                aria-hidden="true"
                style={{ position: 'absolute', bottom: '24px', right: '24px', pointerEvents: 'none' }}
                width="80"
                height="80"
                viewBox="0 0 80 80"
                fill="none"
            >
                <path className="line-path" d="M80 68 L68 68 L68 80" stroke="rgba(0,214,143,0.40)" strokeWidth="1.2" strokeLinecap="round" />
                <path className="line-path" d="M56 68 L40 68" stroke="rgba(255,255,255,0.10)" strokeWidth="1" />
                <path className="line-path" d="M68 56 L68 40" stroke="rgba(255,255,255,0.10)" strokeWidth="1" />
            </svg>

            {/* Content */}
            <div style={{ position: 'relative', zIndex: 1, width: '100%', display: 'flex', justifyContent: 'center' }}>
                {children}
            </div>
        </div>
    );
}
